// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I9B8","option":"styles_option__3WlbN","active":"styles_active__1jyF8"};